// extracted by mini-css-extract-plugin
export default {"tooltip":"d8rjqLP","label":"LPCfdlu","text":"_Md4Wqh"};